// Deadline groups of GET /api/v2/re/alerts that belong to a transaction (ticket 206), for the
// hub's Transactions tab. Same shape as REBoard's RE_ALERT_GROUPS minus Listing Expiring, which
// is an opportunity deadline and not shown here.
import { Home, Search, FileCheck, Landmark, CalendarClock } from 'lucide-react';

export const TX_ALERT_GROUPS = [
  { key: 'option_expiring', title: 'Option Expiring', icon: CalendarClock, field: 'expires_at', idField: 'transaction_id' },
  { key: 'inspection_soon', title: 'Inspection', icon: Search, field: 'date', idField: 'transaction_id' },
  { key: 'appraisal_soon', title: 'Appraisal', icon: FileCheck, field: 'date', idField: 'transaction_id' },
  { key: 'financing_soon', title: 'Financing', icon: Landmark, field: 'date', idField: 'transaction_id' },
  { key: 'closing_soon', title: 'Closing', icon: Home, field: 'date', idField: 'transaction_id' },
];

export const TX_ALERT_DAYS = 14;
